'use client';
import Typography from '@/components/shared/typography/typography.component';
import { Button } from '@mui/material';
import PopupState, { bindMenu, bindTrigger } from 'material-ui-popup-state';
import { SortIcon } from '../../../../public/Images';
import { KeyboardArrowDown } from '@mui/icons-material';
import Menu from '@mui/material/Menu';
import MenuItem from '@mui/material/MenuItem';

import { useSort, useTranslation } from '@/hook';
import colors from '@/theme/colors.module.scss';
import Image from 'next/image';
import styles from './styles.module.scss';
import { SORTING_PLANS } from '@/types/filter.types';

const Sort = ({ filteredCount }: { filteredCount: number }) => {
    const { t } = useTranslation();
    const { setSortOptions, sorting_plan } = useSort();

    const sortData: { [key in SORTING_PLANS]?: string } = {
        [SORTING_PLANS.MOST_RELEVANT]: t('Most Relevant'),
        [SORTING_PLANS.RECENTLY_ADDED]: t('Recently Added'),
        [SORTING_PLANS.PRICE_DESC]: t('Price - Highest to Lowest'),
        [SORTING_PLANS.PRICE_ASC]: t('Price - Lowest to Highest'),
        [SORTING_PLANS.KM_DESC]: t('KMs - Highest to Lowest'),
        [SORTING_PLANS.KM_ASC]: t('KMs - Lowest to Highest'),
        [SORTING_PLANS.YEAR_ASC]: t('Year - Old to New'),
        [SORTING_PLANS.YEAR_DESC]: t('Year - New to Old'),
    };

    return (
        <div className={styles.container_sort_desktop_comp}>
            <Typography color={colors.gray} variant={'body1Bold'}>
                {`${filteredCount} ${t('Sylndr certified cars sort')}`}
            </Typography>
            <div className={styles.inner_container}>
                <Typography color={colors.gray700} variant={'body1SemiBold'}>
                    {t('sortBy')}
                </Typography>
                <PopupState variant="popover" popupId="demo-popup-menu">
                    {popupState => (
                        <>
                            <Button
                                variant="outlined"
                                color="primary"
                                style={{
                                    fontSize: 14,
                                    color: colors.gray700,
                                    borderColor: colors.gray300,
                                    justifyContent: 'space-between',
                                    width: 290,
                                }}
                                {...bindTrigger(popupState)}
                            >
                                <Image
                                    src={SortIcon.src}
                                    alt=""
                                    width={18}
                                    height={18}
                                />
                                <Typography
                                    color={colors.black}
                                    style={{
                                        marginRight: 1,
                                        marginLeft: 1,
                                        fontSize: 14,
                                    }}
                                >
                                    {sortData[sorting_plan] ||
                                        sortData[SORTING_PLANS.MOST_RELEVANT]}
                                </Typography>
                                <KeyboardArrowDown />
                            </Button>

                            <Menu {...bindMenu(popupState)}>
                                {Object.keys(sortData).map((item, index) => {
                                    return (
                                        <MenuItem
                                            key={index.toString()}
                                            sx={[
                                                { width: '290px' },
                                                sortData[item] ===
                                                    sortData[sorting_plan] && {
                                                    bgcolor: colors.primary25,
                                                    color: colors.primary700,
                                                },
                                            ]}
                                            onClick={() => {
                                                setSortOptions(
                                                    SORTING_PLANS[item]
                                                );
                                                popupState.close();
                                            }}
                                        >
                                            <Typography variant={'body2Medium'}>
                                                {' '}
                                                {sortData[item]}{' '}
                                            </Typography>
                                        </MenuItem>
                                    );
                                })}
                            </Menu>
                        </>
                    )}
                </PopupState>
            </div>
        </div>
    );
};

export default Sort;
